export default class NodesList {

    nodes = [];

    constructor(nodes) {
        this.nodes = nodes;
    }

    _initNodes(nodes) {
        const _nodes = nodes;

        this.nodes = _nodes;
    }

    getMaxEndTime() {
        const maxEndTime = this.nodes.reduce((acc, node) => {
            return Math.max(acc, node.endTime);
        }, 0)

        return maxEndTime;
    }

    render(time) {
        this.nodes.forEach((node) => node.render(time));
    }

    setShowAll(isShow = true) {
        this.nodes.forEach((node) => node.setShow(isShow));
    }
}